import Image from 'next/image';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import Icon from '@/components/base/Icon';

export function SparksContextBlock() {
    const { t } = useTranslation('sparks');

    return (
        <div className="flex items-center gap-3">
            <div className="flex size-[50px] shrink-0 items-center justify-center overflow-hidden rounded-[14px] border border-icoGray-300 bg-white shadow-icoXS dark:border-icoDarkMode-beton dark:bg-icoDarkMode-anthracite">
                <Image src="/images/svg/sparks-avatar.svg" alt="Sparks" width={30} height={30} />
            </div>
            <div className="flex flex-col gap-1.5">
                <div className="flex items-center gap-1.5">
                    <span className="font-GBold text-[10px] uppercase leading-3 tracking-wide text-icoGray-500 dark:text-icoDarkMode-wolf">
                        {t('looking_at')}
                    </span>
                </div>
                <div className="flex items-center">
                    <span className="flex items-center gap-1 rounded-full bg-icoGray-100 px-1.5 py-1 dark:bg-icoDarkMode-deepBlack">
                        <Icon
                            icon="analytics"
                            className="text-[10px] text-icoBlack dark:text-white"
                        />
                        <span className="font-GSemiBold text-[8px] uppercase leading-[10px] tracking-wide text-icoBlack dark:text-white">
                            {t('context_overview')}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    );
}
